module.exports = __webpack_public_path__ + "images/icons/logos/italy-white-cf196bd7.svg";